<template>
  <div>
      <table class="table table-hover">
        <tbody>
        <tr>
          <td>Server:</td>
          <td>
            <a-edit-txt
              type="select"
              :options="site.type === 'safe-site' ? serversPpc : servers"
              :selected-value="site.customData.doServer"
              :text="site.customData.doServer"
              @input="$store.dispatch('setCustomData', {domain: site.punyDomain, data: {'doServer': $event}})"
              close-on-save="true"
            ></a-edit-txt>
          </td>
        </tr>
        <tr>
          <td colspan="2" v-if="site.customData.doServer">
            <button
              v-if="this.site.backups && this.site.backups.length && site.software === 'wordpress'"
              class="btn btn-xs btn-primary"
              @click="deployProd(0, 'latest')"
            ><i class="fa fa-upload"></i> Deploy</button>
            <button
              v-if="site.software === 'wordpress'"
              class="btn btn-xs btn-success"
              @click="deployProd(1)"
            ><i class="fa fa-refresh"></i> Rebuild &amp; Deploy</button>
            <i class="fa fa-clock pull-right red" v-tooltip="'Waiting for delayed deploy!'" v-if="site.customData.delayedDeploy"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      servers: [
        'm1-ws1-ams3.aphex.me',
        'money1.ams3.aphex.me',
        'pbn2.ams3.aphex.me',
        'pbn3.ams3.aphex.me',
        'pbn4.ctb.aphex.me'
      ],
      serversPpc: [
        'ppc1.ams3.aphex.me'
      ]
    }
  },
  props: ['site'],
  methods: {
    async deployProd (rebuild = 0, backup = '') {
      if (backup === 'latest' && (!this.site.backups || this.site.backups.length === 0)) {
        this.$toastr.error('No backups', 'Try rebuilding to create new backup from staging')
      }
      await axios.post(`/pbn/site/${this.site.punyDomain}/deploy?rebuild=${rebuild}&backup=${backup}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Build/Hosts/DigitalOcean.vue